import { Analytics } from './analytics';

let emailLinkFilter = $('a[href^="mailto:"]').toArray().filter((e) => {
    return $(this).parent(":not(.header-links-item-popover)");
});

$(emailLinkFilter).click((e) => {
    Analytics.sendRawEvent({
        "event": "click_email",
        "interaction": {
          "click_type": "email",
          "link_url": e.currentTarget.getAttribute("href"),
          "link_text": e.currentTarget.innerText
        }
    })
});